(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const navLinks = document.querySelectorAll('.menu-container .nav_lnk');
    const menuContainers = document.querySelectorAll('.menu-container');
    const body = document.body;

    navLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        const container = this.closest('.menu-container');
        const isActive = container.classList.contains('active');

        // Close all menus first
        menuContainers.forEach((item) => item.classList.remove('active'));

        // Toggle current
        if (!isActive) {
          container.classList.add('active');
          body.classList.add('show__megamenu');
        } else {
          body.classList.remove('show__megamenu');
        }

        e.stopPropagation();
      });
    });

    // Prevent clicks inside menu from bubbling to document
    menuContainers.forEach((container) => {
      container.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    // Click outside → close all
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.menu-container')) {
        menuContainers.forEach((container) => {
          container.classList.remove('active');
        });
        body.classList.remove('show__megamenu');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
